import type { RegularizationRequest } from '../types/hrmsAttendanceDetails.types'
import {
  getAttendanceRegularizations,
  reviewAttendanceRegularization,
} from './hrmsRegularization.api'

export async function getAttendanceRegularization(
  staffId: string,
  date: string
): Promise<RegularizationRequest | null> {
  try {
    const res = await getAttendanceRegularizations({
      staffId: staffId,
      fromDate: date,
      toDate: date,
      limit: 1,
    })
    const item = res.items[0]
    if (!item) return null

    const statusMap: Record<string, RegularizationRequest['status']> = {
      PENDING: 'Pending Approval',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
    }

    return {
      id: item.id,
      employeeId: item.staff?.code || item.staffId,
      requestedCheckIn: item.requestedCheckIn || undefined,
      requestedCheckOut: item.requestedCheckOut || undefined,
      reason: item.detailedReason || item.reasonCategory?.displayName || '',
      requestedAt: item.createdAt,
      status: statusMap[item.status] || 'Pending Approval',
    }
  } catch {
    return null
  }
}

export async function approveRegularization(
  requestId: string
): Promise<RegularizationRequest | null> {
  try {
    const item = await reviewAttendanceRegularization(requestId, { status: 'APPROVED' })
    return {
      id: item.id,
      employeeId: item.staff?.code || item.staffId,
      requestedCheckIn: item.requestedCheckIn || undefined,
      requestedCheckOut: item.requestedCheckOut || undefined,
      reason: item.detailedReason || item.reasonCategory?.displayName || '',
      requestedAt: item.createdAt,
      status: 'Approved',
    }
  } catch {
    return null
  }
}

export async function rejectRegularization(
  requestId: string,
  rejectionReason = 'Rejected by administrator'
): Promise<RegularizationRequest | null> {
  try {
    const item = await reviewAttendanceRegularization(requestId, {
      status: 'REJECTED',
      rejectionReason,
    })
    return {
      id: item.id,
      employeeId: item.staff?.code || item.staffId,
      requestedCheckIn: item.requestedCheckIn || undefined,
      requestedCheckOut: item.requestedCheckOut || undefined,
      reason: item.detailedReason || item.reasonCategory?.displayName || '',
      requestedAt: item.createdAt,
      status: 'Rejected',
    }
  } catch {
    return null
  }
}
